import React, { useState } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import { LatLng } from 'leaflet';
import { useLanguage } from '../utils/LanguageContext';
import 'leaflet/dist/leaflet.css';

interface MapProps {
  onPlaceSelect: (place: {
    name: string;
    address: string;
    location: { lat: number; lng: number };
  }) => void;
}

const SearchControl = ({ onPlaceSelect }: MapProps) => {
  const map = useMap();
  const { t } = useLanguage();
  const [searchText, setSearchText] = useState('');

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchText)}`
      );
      const data = await response.json();
      
      if (data && data[0]) {
        const { lat, lon, display_name } = data[0];
        const location = new LatLng(parseFloat(lat), parseFloat(lon));
        
        map.flyTo(location, 16);
        
        onPlaceSelect({
          name: searchText,
          address: display_name,
          location: { lat: parseFloat(lat), lng: parseFloat(lon) }
        });
      }
    } catch (error) {
      console.error('Error searching location:', error);
    }
  };

  return (
    <form onSubmit={handleSearch} className="map-search-form">
      <input
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder={t('location.search')}
        className="search-input"
      />
      <button type="submit" className="search-button">
        {t('location.searchButton')}
      </button>
    </form>
  );
};

const Map: React.FC<MapProps> = ({ onPlaceSelect }) => {
  return (
    <div className="map-container">
      <MapContainer
        center={[47.4979, 19.0402]} // Budapest coordinates
        zoom={13}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <SearchControl onPlaceSelect={onPlaceSelect} />
      </MapContainer>
    </div>
  );
};

export default Map;
